import React, { useState, useContext } from "react";
import "./Action.css";
import { Button, Modal, Input, TimePicker } from "antd";
import Colors from "../../Helper/Colors";
// import moment from "jalali-moment";
import CustomDatePicker from "../Components/datepicker";
import { useSelector } from "react-redux";
import FormatHelper from "../../Helper/FormatHelper";
import InputSeperator from "../Components/input_seperator";
import { techappContext } from "../../Api/techappReq";
import uploadIcon from "../../assets/images/upload.png";
import galleryIcon from "../../assets/images/gallery.png";
import cameraIcon from "../../assets/images/camera.png";
import ReactModal from "react-modal";
import { toast } from "react-toastify";
import { FaTimes } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import Camera from "../Components/camera";
const { TextArea } = Input;

const DigitalFactorModal = ({
  digitalFactorVisible,
  setDigitalFactorVisible,
}) => {
  const {
    sendAction,
    finalFactor,
    setFinalFactor,
    generateTextReciept,
    generatedReceipt,
    loading,
  } = useContext(techappContext);

  const selectedOrder = useSelector((state) => state.TechAppReducer.orderObj);
  const today = useSelector((state) => state.PannelReducer.today);

  const [buttonSelected, setButtonSelected] = useState(0);
  // receive states
  const [deviceModel, setDeviceModel] = useState("");
  const [serial, setSerial] = useState("");
  const [duration, setDuration] = useState("");
  const [fee, setFee] = useState("");
  const [preFee, setPreFee] = useState("");
  const [technicalError, setTechnicalError] = useState("");
  const [symptoms, setSymptoms] = useState("");
  const [description, setDescription] = useState("");
  // deliver states
  const [amount, setAmount] = useState("");
  const [bankNumber, setBankNumber] = useState("");
  const [bankOwner, setBankOwner] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTimeFrom, setSelectedTimeFrom] = useState("");
  const [selectedTimeTo, setSelectedTimeTo] = useState("");
  const [fileList, setFileList] = useState([]);
  const [imageList, setImageList] = useState([]);
  const [showDoc, setShowDoc] = useState(false);
  const [doc, setDoc] = useState(null);
  const [pickModal, setPickModal] = useState(false);
  const [isCamera, setIsCamera] = useState(false);
  const fileInputRef = React.useRef(null);

  const upload = (e) => {
    let list = [];
    for (var i = 0; i < e.target.files.length; i++) {
      list.push(e.target.files[i]);
      fileList.push(e.target.files[i]);
    }
    list.forEach((li) => {
      imageList.push(URL.createObjectURL(li));
    });
    setFileList([...fileList]);
    setImageList([...imageList]);
  };

  const removeFileHandler = (url, index) => {
    setImageList(imageList.filter((img) => img !== url));
    setFileList(fileList.filter((file, i) => i !== index));
  };

  const onPreview = (url) => {
    setDoc(url);
    setShowDoc(true);
  };

  // const getDate = (date, dateString) => {
  //   setSelectedDate(dateString);
  // };

  const changeTimeFrom = (time, timeString) => {
    setSelectedTimeFrom(timeString);
  };

  const changeTimeTo = (time, timeString) => {
    setSelectedTimeTo(timeString);
  };

  const submitDigitalFactor = async (e) => {
    e.preventDefault();
    if (buttonSelected === 0) {
      generateTextReciept({
        receipt_type: 0,
        order_id: selectedOrder.id,
        device_model: deviceModel,
        device_number: serial,
        time: duration,
        fee: fee,
        pre_fee: preFee,
        symptom: symptoms,
        error: technicalError,
        desc: description,
        file: fileList,
      });
    } else {
      generateTextReciept({
        receipt_type: 1,
        order_id: selectedOrder.id,
        give_amount: amount,
        bank_number: bankNumber,
        bank_owner_name: bankOwner,
        delivery_date: `${selectedDate?.year}-${selectedDate?.month}-${selectedDate?.day}`,
        delivery_time: selectedTimeFrom
          ? selectedTimeFrom + " تا " + selectedTimeTo
          : "",
        file: fileList,
      });
    }
  };

  return (
    <>
      <Modal
        ariaHideApp={false}
        open={digitalFactorVisible}
        onCancel={() => setDigitalFactorVisible(false)}
        className="techapp-action-digital-factor-modal"
        style={{ borderRadius: "6px", textAlign: "center" }}
        title={"لطفا جزییات رسید را وارد کنید (جاهای خالی را پر کنید)"}
        footer={<></>}
      >
        <div className="tech-app-action-digital-factor">
          {/* tabs */}
          <div className="tech-app-action-digital-factor-buttons">
            <Button
              onClick={() => setButtonSelected(1)}
              style={
                buttonSelected === 1
                  ? { backgroundColor: Colors.warning }
                  : { backgroundColor: "white", color: Colors.secondary }
              }
            >
              تحویل دستگاه به مشتری
            </Button>
            <Button
              onClick={() => setButtonSelected(0)}
              style={
                buttonSelected === 0
                  ? { backgroundColor: Colors.warning }
                  : { backgroundColor: "white", color: Colors.secondary }
              }
            >
              دریافت دستگاه از مشتری
            </Button>
          </div>
          {/* btn select === 1 */}
          {buttonSelected === 1 && (
            <>
              <InputSeperator
                value={amount}
                setValue={setAmount}
                className={"ant-input"}
                placeHolder={"مبلغ واریزی مشتری(تومان)"}
                style={{
                  width: "100%",
                  maxHeight: "100px",
                  textAlign: "right",
                  borderRadius: "6px",
                  margin: "12px 0 3px 0",
                  padding: "1px 11px",
                }}
              />
              <Input
                value={bankNumber}
                style={{
                  width: "100%",
                  borderRadius: "6px",
                  margin: "12px 0 3px 0",
                  padding: "1px 11px",
                  textAlign: "right",
                }}
                onChange={(e) => setBankNumber(e.target.value)}
                placeholder={"شماره کارت بانکی"}
              />
              <Input
                defaultValue={bankOwner}
                onChange={(e) => setBankOwner(e.target.value)}
                style={{ textAlign: "right" }}
                placeholder={"نام صاحب حساب"}
              />
              <CustomDatePicker
                // disabled={loadings.create}
                inputClassName="digital_receipt_datepicker"
                value={selectedDate}
                minimumDate={today}
                onChange={(value) => {
                  setSelectedDate(value);
                }}
                inputPlaceholder="بازه زمانی تحویل را انتخاب کنید"
              />
              <div className="tech-app-action-digital-factor-time-picker">
                <span>{"ساعت تحویل از"}</span>
                <TimePicker
                  placeholder="انتخاب"
                  onChange={changeTimeFrom}
                  disabled={!selectedDate}
                  // disabledHours={() => {
                  //   let array = [];
                  //   for (let index = 0; index < moment().get("hour"); index++) {
                  //     array.push(index);
                  //   }
                  //   if (
                  //     selectedDate?.year === today?.year &&
                  //     selectedDate?.month === today?.month &&
                  //     selectedDate?.day === today?.day
                  //   ) {
                  //     return array;
                  //   }
                  // }}
                  // disabledMinutes={() => {
                  //   let array = [];
                  //   for (
                  //     let index = 0;
                  //     index < moment().get("minute");
                  //     index++
                  //   ) {
                  //     array.push(index);
                  //   }
                  //   if (
                  //     selectedDate?.year === today?.year &&
                  //     selectedDate?.month === today?.month &&
                  //     selectedDate?.day === today?.day
                  //   ) {
                  //     return array;
                  //   }
                  // }}
                  format={"HH:mm"}
                  suffixIcon={null}
                  clearIcon={false}
                  showNow={false}
                />
                <span>تا</span>
                <TimePicker
                  placeholder="انتخاب"
                  format={"HH:mm"}
                  onChange={changeTimeTo}
                  disabled={selectedTimeFrom.length === 0}
                  // disabledHours={() => {
                  //   let array = [];
                  //   for (
                  //     let index = 0;
                  //     index < parseFloat(selectedTimeFrom.split(":")[0]);
                  //     index++
                  //   ) {
                  //     array.push(index);
                  //   }
                  //   return array;
                  // }}
                  // disabledMinutes={() => {
                  //   let array = [];
                  //   for (
                  //     let index = 0;
                  //     index < parseFloat(selectedTimeFrom.split(":")[1]);
                  //     index++
                  //   ) {
                  //     array.push(index);
                  //   }
                  //   return array;
                  // }}
                  suffixIcon={null}
                  clearIcon={false}
                  showNow={false}
                />
              </div>
            </>
          )}
          {/* btn select === 0 */}
          {buttonSelected === 0 && (
            <>
              {/* device model */}
              <Input
                value={deviceModel}
                onChange={(e) => setDeviceModel(e.target.value)}
                placeholder={"مدل دستگاه یا قطعه ی انتقالی"}
                style={{ textAlign: "right" }}
              />
              {/* serial */}
              <Input
                value={serial}
                onChange={(e) => setSerial(e.target.value)}
                placeholder={"شماره سریال قطعه"}
                style={{ textAlign: "right" }}
              />
              {/* duration */}
              <Input
                style={{
                  width: "100%",
                  borderRadius: "6px",
                  margin: "12px 0 3px 0",
                  padding: "1px 11px",
                  textAlign: "right",
                }}
                Value={setDuration}
                onChange={(e) => setDuration(e.target.value)}
                placeholder={"زمان تقریبی(روز کاری)"}
              />
              {/* fee */}
              <InputSeperator
                value={fee}
                setValue={setFee}
                className={"ant-input"}
                placeHolder={"هزینه تقریبی(تومان)"}
                style={{
                  width: "100%",
                  maxHeight: "100px",
                  textAlign: "right",
                  borderRadius: "6px",
                  marginBottom: "10px",
                }}
              />
              {/* pre fee */}
              <InputSeperator
                value={preFee}
                setValue={setPreFee}
                className={"ant-input"}
                placeHolder={"مبلغ بیعانه(تومان)"}
                style={{
                  width: "100%",
                  maxHeight: "100px",
                  textAlign: "right",
                  borderRadius: "6px",
                  marginBottom: "10px",
                }}
              />
              {/* technical error */}
              <Input
                value={technicalError}
                onChange={(e) => setTechnicalError(e.target.value)}
                placeholder={"اشکال فنی"}
                style={{ textAlign: "right" }}
              />
              {/* symptoms */}
              <Input
                value={symptoms}
                onChange={(e) => setSymptoms(e.target.value)}
                placeholder={"ایرادات ظاهری"}
                style={{ textAlign: "right" }}
              />
              {/* description */}
              <TextArea
                autoSize
                inputMode="text"
                value={description}
                placeholder={"توضیحات"}
                id="create_order_digital_factor_description"
                onChange={(e) => setDescription(e.target.value)}
                style={{
                  textAlign: "right",
                  maxHeight: "120px",
                  paddingTop: "10px",
                  marginTop: "10px",
                  borderRadius: "5px",
                }}
              />
            </>
          )}
          {/* file input (multiple files) */}
          <div
            style={{
              marginTop: "12px",
              textAlign: "right",
            }}
          >
            <div
              onClick={() => setPickModal(true)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                border: "1px dashed " + Colors.royalBlue,
                borderRadius: "6px",
                padding: "10px",
              }}
            >
              <span>انتخاب فایل</span>
              <img
                src={uploadIcon}
                alt="upload"
                style={{ width: "20px", marginLeft: "8px" }}
              />
            </div>
            <input
              ref={fileInputRef}
              onChange={upload}
              type="file"
              multiple
              style={{ display: "none" }}
            />
            {imageList.length > 0 && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  marginTop: "8px",
                }}
              >
                {imageList.map((url, index) => (
                  <div
                    key={index}
                    style={{ position: "relative", margin: "5px" }}
                  >
                    <img
                      onClick={() => onPreview(url)}
                      src={url}
                      className="techapp-ticket-upload-image"
                      alt={"image" + index}
                    />
                    <span
                      onClick={() => removeFileHandler(url, index)}
                      style={{ left: "-5px" }}
                      className="techapp-upload-remove-btn"
                    >
                      x
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
          {/* action buttons */}
          <div style={{ marginTop: "10px" }}>
            <Button
              onClick={() => setDigitalFactorVisible(false)}
              className="tech-app-reset-data-btns btn-text-black"
              disabled={loading}
              style={{
                backgroundColor: "rgba(199, 199, 199, 0.322)",
                color: "black",
              }}
            >
              انصراف
            </Button>
            <Button
              onClick={submitDigitalFactor}
              loading={loading}
              className="tech-app-reset-data-btns btn-text-white"
              style={{ backgroundColor: Colors.royalBlue, color: "white" }}
              id="order_digital_factor_form_submit_button"
            >
              ثبت
            </Button>
          </div>
        </div>
      </Modal>
      {/* check factor modal */}
      <Modal
        ariaHideApp={false}
        open={finalFactor}
        onCancel={() => setFinalFactor(false)}
        style={{ borderRadius: "6px", textAlign: "center" }}
        title={
          <span style={{ color: Colors.success }}>
            پیغام زیر برای مشتری ارسال خواهد شد
          </span>
        }
        footer={<></>}
      >
        <div
          style={{
            height: "400px",
            whiteSpace: "pre-wrap",
            overflow: "scroll",
          }}
          className="reciept-span mv-remove-scroll"
        >
          {FormatHelper.toPersianString(generatedReceipt)}
        </div>
        <div style={{ marginTop: "10px" }}>
          <Button
            onClick={() => setFinalFactor(false)}
            className="tech-app-reset-data-btns btn-text-black"
            disabled={loading}
            style={{
              backgroundColor: "rgba(199, 199, 199, 0.322)",
              color: "black",
            }}
          >
            انصراف
          </Button>
          <Button
            onClick={() => sendAction(21)}
            className="tech-app-reset-data-btns btn-text-white"
            style={{ backgroundColor: Colors.royalBlue, color: "white" }}
            loading={loading}
            id="order_digital_factor_review_submit_button"
          >
            ارسال
          </Button>
        </div>
      </Modal>
      {/* show doc modal */}
      {showDoc && doc && (
        <ReactModal
          ariaHideApp={false}
          isOpen={true}
          onRequestClose={() => setShowDoc(false)}
          className="tech-app-view-order-showdoc-modal"
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          }}
        >
          <FaTimes
            onClick={() => setShowDoc(false)}
            style={{
              color: "white",
              cursor: "pointer",
              position: "absolute",
              right: "30px",
              top: "20px",
              fontSize: "22px",
            }}
          />
          <img
            style={{ width: "100%", objectFit: "cover" }}
            src={doc}
            alt="doc"
          />
        </ReactModal>
      )}
      {/* pick modal */}
      <ReactModal
        ariaHideApp={false}
        isOpen={pickModal}
        onRequestClose={() => setPickModal(false)}
        className="tech-app-view-order-modal"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.551)",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
            zIndex: "10000",
          },
        }}
      >
        <p style={{ padding: "10px", marginBottom: "20px" }}>
          <IoIosArrowDown
            style={{ cursor: "pointer", padding: "0 10px" }}
            onClick={() => setPickModal(false)}
          />
          <span>انتخاب عکس</span>
        </p>
        <div
          onClick={() => {
            fileInputRef.current && fileInputRef.current.click();
            setPickModal(false);
          }}
          style={{
            color: "black",
            display: "flex",
            alignItems: "center",
            padding: "15px 10px",
            marginBottom: "20px",
          }}
        >
          <img
            src={galleryIcon}
            alt="icon"
            style={{ width: "20px", marginLeft: "10px" }}
          />
          گالری
        </div>
        <div
          onClick={() => {
            if (window.outerWidth > 800) {
              toast.warning(
                "برای استفاده از دوربین باید از موبایل استفاده کنید"
              );
            } else {
              setIsCamera(true);
              setPickModal(false);
            }
          }}
          style={{
            color: "black",
            display: "flex",
            alignItems: "center",
            padding: "15px 10px",
            marginBottom: "20px",
          }}
        >
          <img
            src={cameraIcon}
            alt="icon"
            style={{ width: "20px", marginLeft: "10px" }}
          />
          دوربین
        </div>
      </ReactModal>
      {/* camera modal */}
      <ReactModal
        ariaHideApp={false}
        isOpen={isCamera}
        onRequestClose={() => setIsCamera(false)}
        className="tech-app-view-order-modal h-100"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.551)",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
            zIndex: "10000",
          },
        }}
      >
        <Camera modal={setIsCamera} fileList={fileList} imageList={imageList} />
      </ReactModal>
    </>
  );
};
export default DigitalFactorModal;
